module.exports = __webpack_public_path__ + "img/close-button.3bf6d3cb.svg";